import { Controller } from "@hotwired/stimulus"
import _ from "lodash"

export default class extends Controller {
  connect() {
    this.debouncedSubmit = _.debounce(() => this.element.requestSubmit(), 500)
    this.cancelPendingSubmit = () => this.debouncedSubmit.cancel()

    this.element.addEventListener(`submit`, this.cancelPendingSubmit)
  }

  disconnect() {
    this.element.removeEventListener(`submit`, this.cancelPendingSubmit)
    this.debouncedSubmit.cancel()
  }

  submit() {
    this.debouncedSubmit()
  }
}
